import { useCallback, useEffect, useLayoutEffect, useRef } from 'react';

const useKeystoneCheckedCirclePositioner = () => {
  const circleRef = useRef<SVGSVGElement>(null);
  const textRef = useRef<SVGTextElement>(null);

  const handleResize = useCallback(() => {
    if (!circleRef.current || !textRef.current) {
      return;
    }

    const { x, width } = textRef.current.getBBox();

    circleRef.current.setAttribute('x', `${x - width / 2}`);
  }, [circleRef, textRef]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  useLayoutEffect(() => {
    setTimeout(() => {
      handleResize();
    }, 300);
  }, [handleResize]);

  return [circleRef, textRef] as const;
};

export default useKeystoneCheckedCirclePositioner;
